module.exports = __webpack_public_path__ + "static/media/unlink.e3a6a659.svg";